<template>
  <div class="colors">
    <carousel
      :perPageCustom="[[300, 1], [768, 3]]"
      pagination-active-color="#ffffff"
      pagination-color="rgba(213, 207, 198, .3)"
      :pagination-padding="10"
    >
      <slide>
        <div
          ref="primaryColorPicker"
          class="color-picker"
        ></div>
      </slide>
      <slide>
        <div
          ref="secondaryColorPicker"
          class="color-picker"
        ></div>
      </slide>
      <slide>
        <div
          ref="accentColorPicker"
          class="color-picker"
        ></div>
      </slide>
    </carousel>
  </div>
</template>

<script>
  import iro from "@jaames/iro";
  import { mapState, mapActions } from "vuex";

  export default {
    name: "ColorsSelect",
    data() {
      return {
        perPage: 3
      };
    },
    computed: {
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder
      })
    },
    methods: {
      ...mapActions(["softUpdatePathfinder"]),
      getColor(colorRef) {
        return this.pathfinder[colorRef];
      },
      setColor(colorRef, value) {
        this.softUpdatePathfinder({ [colorRef]: value });
      },
      setUpColorPicker(el, colorRef) {
        const picker = new iro.ColorPicker(el, {
          // Set the size of the color picker UI
          width: 170,
          height: 170,
          markerRadius: 10,
          padding: 4,
          sliderMargin: 10,
          sliderHeight: 24,
          borderWidth: 3,
          borderColor: "#fff",
          anticlockwise: true,
          // Set the initial color to red
          color: this.getColor(colorRef)
        });

        picker.on("color:change", (color, changes) => {
          // Log the color's hex RGB value to the dev console
          this.setColor(colorRef, color.hexString);
        });

        setTimeout(() => {
          picker.svg.el.addEventListener(
            "touchstart",
            e => {
              e.stopPropagation();
            },
            { passive: true }
          );
          picker.svg.el.addEventListener(
            "mousedown",
            e => {
              e.stopPropagation();
            },
            { passive: true }
          );
        }, 1000); // Takes a moment for the element to be created
      }
    },
    mounted() {
      this.setUpColorPicker(this.$refs.primaryColorPicker, "primary_color");
      this.setUpColorPicker(this.$refs.secondaryColorPicker, "secondary_color");
      this.setUpColorPicker(this.$refs.accentColorPicker, "accent_color");
    }
  };
</script>

<style>
  .color-picker svg {
    margin: auto;
  }
</style>
